import { api } from './http';

export type AppName = 'admin' | 'console' | 'customer';
export type MemberRole = 'ADMIN' | 'MAKER' | 'APPROVER' | 'VIEWER';
export interface Company { id: string; reference: string; name: string; role: MemberRole }
export interface SessionUser {
  displayName: string; userType: 'STAFF' | 'CUSTOMER'; roles: string[];
  /** Staff only: their own user id (e.g. "assign to me"; four-eyes hints). */
  id?: string;
  /** Customers only: the selected company (null while an applicant has no approved company). */
  company?: Company | null;
}
export interface SignupForm {
  accountType: 'INDIVIDUAL' | 'BUSINESS'; email: string; mobile: string; password: string; country: string; acceptTerms: boolean;
}

export const authApi = {
  login: (app: AppName, email: string, password: string) => api<{ next: 'MFA' | 'ENROL_MFA' }>('POST', `/auth/${app}/login`, { email, password }),
  verifyMfa: (app: AppName, code: string) => api<{ user: SessionUser }>('POST', `/auth/${app}/mfa`, { code }),
  session: (app: AppName) => api<{ user: SessionUser }>('GET', `/auth/${app}/session`),
  stepUp: (app: AppName, code: string) => api<void>('POST', `/auth/${app}/step-up`, { code }),
  logout: (app: AppName) => api<void>('POST', `/auth/${app}/logout`),
};

/** Customer app only: sign-up (P-01), email link, authenticator set-up, company selector (P-C0). */
export const customerAuthApi = {
  signUp: (form: SignupForm) => api<{ next: 'CHECK_EMAIL' }>('POST', '/auth/customer/signup', form),
  resendVerification: (email: string) => api<{ next: 'CHECK_EMAIL' }>('POST', '/auth/customer/resend-verification', { email }),
  verifyEmail: (token: string) => api<{ next: 'ENROL_MFA' }>('POST', '/auth/customer/verify-email', { token }),
  /** "Forgot your password?": the same answer for every address. */
  requestPasswordReset: (email: string) => api<{ next: 'CHECK_EMAIL' }>('POST', '/auth/customer/password-reset', { email }),
  confirmPasswordReset: (b: { token: string; password: string; code?: string }) => api<void>('POST', '/auth/customer/password-reset/confirm', b),
  beginEnrolment: () => api<{ secret: string; otpauthUri: string }>('POST', '/auth/customer/enrol'),
  confirmEnrolment: (code: string) => api<{ user: SessionUser }>('POST', '/auth/customer/enrol/confirm', { code }),
  profile: () => api<{ email: string; accountType: 'INDIVIDUAL' | 'BUSINESS' | null; country: string | null }>('GET', '/auth/customer/profile'),
  companies: () => api<{ companies: Company[]; selected: string | null }>('GET', '/auth/customer/companies'),
  selectCompany: (customerId: string) => api<{ user: SessionUser }>('POST', '/auth/customer/companies/select', { customerId }),
};
